"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ButtonArrowIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gatsby = require("gatsby");
var _utils = require("../../../utils/utils");
require("../../../utils/_variables.css");
// Packages

// Components

// Utils

// Styles
const {
  canHover
} = (0, _utils.getMediaQueries)();
const ButtonIcon = _styledComponents.default.button.withConfig({
  displayName: "arrow__ButtonIcon",
  componentId: "sc-imk614-0"
})(["background:transparent;border:none;cursor:pointer;&:not([disabled]){", " svg{circle{fill:", ";stroke:", ";transition:all 0.2s ease-in-out;}path{stroke:", ";transition:all 0.2s ease-in-out;}}}&:not([disabled]):active,&:not([disabled]):focus{svg{circle{fill:", ";stroke:", ";}path{stroke:", ";}}}&[disabled]{cursor:not-allowed;svg{circle{stroke:var(--grey-4-hex);transition:all 0.2s ease-in-out;}path{stroke:var(--grey-4-hex);transition:all 0.2s ease-in-out;}}}"], canHover`
      &:hover {
        svg {
          circle {
            fill: ${props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex};
            stroke: ${props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex};
          }
          path {
            stroke: ${props => props.$iconBorderActiveColor || undefined};
          }
        }
      }
    `, props => props.$circleDefaultColor || undefined, props => props.borderDefaultColor || undefined, props => props.$iconBorderDefaultColor || undefined, props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex, props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex, props => props.$iconBorderActiveColor || undefined);
function ButtonArrowIcon({
  circleDefaultColor,
  circleActiveColor,
  iconBorderDefaultColor,
  iconBorderActiveColor,
  borderDefaultColor,
  borderActiveColor,
  icon,
  circleHeight,
  circleWidth,
  title,
  functions,
  buttonAttributes,
  linkAttributes
}) {
  let selectedIcon;
  switch (icon) {
    default:
    case "arrow-up":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Up Arrow", /*#__PURE__*/_react.default.createElement("circle", {
        cx: "16",
        cy: "16.2012",
        r: "15.5",
        transform: "rotate(-90 16 16.2012)",
        stroke: "#F7FAFC"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 20.7012V11.7012",
        stroke: "#F7FAFC",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.625 15.0762L16 11.7012L19.375 15.0762",
        stroke: "#F7FAFC",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
      break;
    case "arrow-left":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Left Arrow", /*#__PURE__*/_react.default.createElement("circle", {
        cx: "16.5",
        cy: "16",
        r: "15.75",
        stroke: "#5C6677",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 16H12",
        stroke: "#5C6677",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.375 12.625L12 16L15.375 19.375",
        stroke: "#5C6677",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
      break;
    case "arrow-right":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Right Arrow", /*#__PURE__*/_react.default.createElement("circle", {
        cx: "16.5",
        cy: "16",
        r: "15.75",
        stroke: "#5C6677",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 16H21",
        stroke: "#5C6677",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.625 12.625L21 16L17.625 19.375",
        stroke: "#5C6677",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
      break;
  }
  return /*#__PURE__*/_react.default.createElement(ButtonIcon, Object.assign({}, functions, linkAttributes, buttonAttributes, {
    $circleDefaultColor: circleDefaultColor,
    $circleActiveColor: circleActiveColor,
    $borderDefaultColor: borderDefaultColor,
    $borderActiveColor: borderActiveColor,
    $iconBorderDefaultColor: iconBorderDefaultColor,
    $iconBorderActiveColor: iconBorderActiveColor,
    as: linkAttributes ? linkAttributes.href ? "a" : _gatsby.Link : "button"
  }), selectedIcon);
}
ButtonArrowIcon.propTypes = {
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets height of icon circle
   */
  circleHeight: _propTypes.default.number,
  /**
   * Sets width of icon circle
   */
  circleWidth: _propTypes.default.number,
  /**
   * Sets default color of icon circle
   */
  circleDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon circle
   */
  circleActiveColor: _propTypes.default.string,
  /**
   * Sets default border color of icon
   */
  iconBorderDefaultColor: _propTypes.default.string,
  /**
   * Sets active border color of icon
   */
  iconBorderActiveColor: _propTypes.default.string,
  /**
   * Sets default color of border around icon circle
   */
  borderDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of border around icon circle
   */
  borderActiveColor: _propTypes.default.string,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string,
  /**
   * Button Functions, e.g. { onClick: () => {}}
   */
  functions: _propTypes.default.shape(),
  /**
   * Button Attributes e.g. { type: "submit"}
   */
  buttonAttributes: _propTypes.default.shape(),
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape()
};
ButtonArrowIcon.defaultProps = {
  circleHeight: 33,
  circleWidth: 32
};
ButtonArrowIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonArrowIcon",
  "props": {
    "circleHeight": {
      "defaultValue": {
        "value": "33",
        "computed": false
      },
      "description": "Sets height of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleWidth": {
      "defaultValue": {
        "value": "32",
        "computed": false
      },
      "description": "Sets width of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "circleDefaultColor": {
      "description": "Sets default color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleActiveColor": {
      "description": "Sets active color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderDefaultColor": {
      "description": "Sets default border color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderActiveColor": {
      "description": "Sets active border color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderDefaultColor": {
      "description": "Sets default color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderActiveColor": {
      "description": "Sets active color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "functions": {
      "description": "Button Functions, e.g. { onClick: () => {}}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "buttonAttributes": {
      "description": "Button Attributes e.g. { type: \"submit\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    }
  }
};